<div class="cart" *ngIf="isVisible$ | async" directive-cart-popup="popup"
    [ngClass]="{'-empty': !(quantity$ | async), '-animate-in': (popupAnimation$ | async) === 'in', '-animate-out': (popupAnimation$ | async) === 'out'}">

    <div class="cart__indicator" directive-cart-indicator></div>

    <div class="cart__inner">
        <shared-circle-btn class="cart__close" (onClick)="handleCloseClick($event)" icon="close" feel="dark">
        </shared-circle-btn>
        <ng-container [ngSwitch]="true">

            <shared-cart-for-default *ngSwitchCase="(quantity$ | async) > 0"></shared-cart-for-default>

            <shared-cart-for-empty *ngSwitchDefault></shared-cart-for-empty>

        </ng-container>
    </div>
</div>
<shared-cart-view></shared-cart-view>
